// eslint-disable-next-line import/prefer-default-export
export const fullName = user => [user.firstName, user.lastName].join(' ');
